// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hyper-link__dialog .el-dialog{margin-right:0}.hyper-link__dialog .el-dialog__body{max-height:300px;overflow-y:scroll;padding:25px 0!important}", ""]);
// Exports
module.exports = exports;
